import API from "../../../helpers/devApi";

const API_ENDPOINTS = "/hrms_job_application";

// Create  new Requisiton
export function createJobDescription(data) {
  return API.post(API_ENDPOINTS, data);
}

export function getSortedApplicantList(bodyData, currentPage, pageSize) {
  return API.post(
    `/hrms_job_application/applicant_sorted?page=${currentPage}&size=${pageSize}`,
    bodyData
  );
}
export function getSortedApplicantListForPaginate(
  bodyData,
  currentPage,
  pageSize
) {
  return API.post(`/hrms_job_application/applicant_sorted`, bodyData);
}
export function getPublicationOrganizations() {
  return API.get(`/hrms_job_application/publications`);
}
export function getMejorSubjects() {
  return API.get(`/hrms_job_application/major_subjects`);
}
export function getEducationLevels() {
  return API.get(`/hrms_job_application/education_level`);
}

export function getInterviewScheduleList(payload) {
  return API.post(`hrms_interview_schedule/getShedult`, payload);
}

export function getApprovedInterviewScheduleList(payload) {
  return API.post(`hrms_interview_schedule/getPassedShedult`, payload);
}

export function getOneApplicantDetails(payload) {
  return API.post(`/sys_users/get/resume/shoprt/details`, payload);
}

export function getOneApplicant(id) {
  return API.get(`${API_ENDPOINTS}/${id}`);
}

// UPDATE Requisiton by ID
export function updateJobDescription(data, id) {
  return API.patch(`${API_ENDPOINTS}/${id}`, data);
}

// DELETE  Requisiton information from server
export function deleteJobDescription(id) {
  return API.delete(`${API_ENDPOINTS}/${id}`);
}

export function getQuestionsByJobDescription(applicantId, id, type_id) {
  return API.get(
    `hrms_applicant_assessment/getInfoByApplicantNJd/${applicantId}/${id}/${type_id}`
  );
}

export function getInterviewers(applicantId, jobId, type_id) {
  return API.post(`hrms_interview_schedule/get/assesors/data`, {
    job_id: Number(jobId),
    applicant_id: Number(applicantId),
    interview_type: Number(type_id),
  });
}

export function getQuestionsByJob(id) {
  return API.post(`/hrms_interview_schedule/interviwe/ongoing/check/by/job`, {
    job_id: id,
  });
}

export function createEducation(data) {
  return API.post(`/hrms_user_education`, data);
}

export function createEducationForApplicant(data) {
  return API.post(`/sys_users/hrms_education/store/inCareerPortal`, data);
}

export function createCertificate(data) {
  return API.post(`/hrms_user_professional_certification`, data);
}

export function createCertificateForApplicant(data) {
  return API.post(
    `/sys_users/hrms_professional_certification/store/inCareerPortal`,
    data
  );
}

export function createExperience(data) {
  return API.post(`/hrms_user_experience`, data);
}

export function createExperienceForApplicant(data) {
  return API.post(`/sys_users/hrms_experience/store/inCareerPortal`, data);
}

export function createTraining(data) {
  return API.post(`/hrms_user_training`, data);
}

export function createTrainingForapplicant(data) {
  return API.post(`/sys_users/hrms_training/store/inCareerPortal`, data);
}

export function updateTraining(data, id) {
  return API.patch(`/hrms_user_training/${id}`, data);
}

export function updateTrainingForApplicant(data, id) {
  return API.patch(
    `/sys_users/hrms_training/update/inCareerPortal/${id}`,
    data
  );
}

export function deleteTraining(id) {
  return API.delete(`/hrms_user_training/${id}`);
}

export function deleteTrainingForApplicant(id) {
  return API.delete(`/sys_users/hrms_training/delete/inCareerPortal/${id}`);
}

export function getEducationById(id) {
  return API.get(`${API_ENDPOINTS}/hrms_education/${id}`);
}

export function getAssessmentList(payload) {
  return API.post(`/hrms_applicant_assessment/getByAvg`, payload);
}

export function getEducationByApplicantId(id) {
  return API.get(`/hrms_education/applicant_education/${id}`);
}

export function getEducation() {
  return API.get(`/hrms_education_level`);
}

export function getEducationForApplicantId(id) {
  return API.get(`/sys_users/hrms_education/get/${id}`);
}

export function getCertificateByApplicantId(id) {
  return API.get(`/hrms_professional_certification/byApplicantId/${id}`);
}

export function getCertificateForApplicantId(id) {
  return API.get(`/sys_users/getAllprof_cert/get/${id}`);
}

export function getDocumentByApplicantId(id) {
  return API.get(`/hrms_user_required_documents/byUserId/${id}`);
}

export function getDocumentForApplicantId(id) {
  return API.get(`/sys_users/getAllDocuments/get/${id}`);
}

export function getDocumentType() {
  return API.get(`/hrms_documents_config/getDesigantionWiseDocuments`);
}

export function getAllNationality() {
  return API.get(`/hrms_nationality`);
}

export function getEmployeeList() {
  return API.get(`/sys_users`);
}

export function getJobList(payload) {
  return API.post(`/hrms_job/list`, payload);
}

export function getInterviewJobList(payload) {
  return API.post(`/hrms_job/list/for/interview/job`, payload);
}

export function getInterviewJobListByType(job_id, interview_type_id) {
  return API.get(
    `/hrms_interview_schedule/scheduleInfo/${job_id}/${interview_type_id}`
  );
}

export function getInterviewScheduleInfo(id) {
  return API.get(`/hrms_interview_schedule/change/sheduleInfo/${id}?exCondi=1`);
}

export function getExperiencedByApplicantId(id) {
  return API.get(`/hrms_user_experience/byUserId/${id}`);
}

export function getExperiencedForApplicantId(id) {
  return API.get(`/hrms_experience/byApplicantId/${id}`);
}

// UPDATE Requisiton by ID
export function updateEducation(data, id) {
  return API.patch(`/hrms_user_education/${id}`, data);
}

export function updateEducationForApplicant(data, id) {
  return API.patch(
    `/sys_users/hrms_education/update/inCareerPortal/${id}`,
    data
  );
}

export function updateExperienced(data, id) {
  return API.patch(`/hrms_user_experience/${id}`, data);
}

export function updateExperiencedForApplicant(data, id) {
  return API.patch(
    `/sys_users/hrms_experience/update/inCareerPortal/${id}`,
    data
  );
}

export function updateCertificate(data, id) {
  return API.patch(`/hrms_user_professional_certification/${id}`, data);
}

export function updateCertificateForApplicant(data, id) {
  return API.patch(
    `/sys_users/hrms_professional_certification/update/inCareerPortal/${id}`,
    data
  );
}

// DELETE  Requisiton information from server
export function deleteEducation(id) {
  return API.delete(`/hrms_user_education/${id}`);
}

export function deleteEducationForApplicant(id) {
  return API.delete(`/sys_users/hrms_education/delete/inCareerPortal/${id}`);
}

export function deleteCertificate(id) {
  return API.delete(`/hrms_user_professional_certification/${id}`);
}

export function deleteCertificateForApplicant(id) {
  return API.delete(
    `/sys_users/hrms_professional_certification/delete/inCareerPortal/${id}`
  );
}

export function deleteExperienced(id) {
  return API.delete(`/hrms_user_experience/${id}`);
}

export function deleteExperiencedForApplicant(id) {
  return API.delete(`/sys_users/hrms_experience/delete/inCareerPortal/${id}`);
}

export function getAllEducationLavel() {
  return API.get(`/hrms_education_level`);
}

export function getAllDegree() {
  return API.get(`/hrms_degree`);
}

export function getAllResultType() {
  return API.get(`/hrms_result_type`);
}

export function getAllBoard() {
  return API.get(`/hrms_board`);
}

export function getAllInstitute() {
  return API.get(`/hrms_institute`);
}

export function getAllMajorSubject() {
  return API.get(`/hrms_major_subject`);
}

export function getAllDivision() {
  return API.get(`/hrms-applicant-portal/sys_geo_divisions`);
}

export function getAllDistrict(division) {
  return API.get(
    `/hrms-applicant-portal/sys_geo_districts/district_by_division/${division}`
  );
}

export function getAllBranchByBank(id) {
  return API.get(`/hrms-applicant-portal/hrms_branch/byBank/${id}`);
}

export function getAllThana(division, district) {
  return API.get(
    `/hrms-applicant-portal/hrms_thana/get_thana_by_div_dist/${division}/${district}`
  );
}

export function getEmployeePersonalInfo(id) {
  return API.post(`/sys_users/getUserByMail`, { applicant_id: id });
}

export function getApplicantPersonalInfo(id) {
  return API.get(`/hrms_applicant/${id}`);
  // return API.get(`http://localhost:6003/api/v1/hrms_applicant/${id}`);
}

export function getPublicationCommonData(applicantId) {
  return API.get(
    `/hrms-applicant-portal/hrms_publication_common/byApplicant/${applicantId}`
  );
}

export function getPublicationData(applicantId) {
  return API.get(`/hrms_user_publication/summary/${applicantId}`);
}

export function getCertificationList() {
  return API.get(`/hrms_certification`);
}

export function getIndustryType() {
  return API.get(`/hrms_industry_type`);
}

export function getTrainingList(id) {
  return API.get(`/hrms_training/applicantId/${id}`);
}

export function getTrainingListForApplicant(id) {
  return API.get(`/sys_users/hrms_training/get/${id}`);
}

export function getCountryList() {
  return API.get(`/config_countries`);
}

export function getAdditionalInfo(id) {
  return API.get(`/hrms_user_additional_information/byUserId/${id}`);
}

export function getAdditionalInfoForApplicant(id) {
  return API.get(`/sys_users/hrms_additional_information/get/${id}`);
}
export function getEmployeeUsers() {
  return API.get(`/sys_users/dropdown-by-branch`);
}
export function getReferenceList(id) {
  return API.get(`/hrms_user_references/byUserId/${id}`);
}

export function getReferenceListForApplicant(id) {
  return API.get(`/sys_users/hrms_references/get/${id}`);
}

export function getLanguageList(id) {
  return API.get(`/hrms_user_language_proficiency/byUserId/${id}`);
}

export function getLanguageListForApplicant(id) {
  return API.get(`/sys_users/hrms_language_proficiency/get/${id}`);
}

export function getPublicationList(id) {
  return API.get(`/hrms_user_publication/byUserId/${id}`);
}

export function getPublicationListForApplicant(id) {
  return API.get(`/hrms_publication/byApplicant/${id}`);
}

export function getPortfolioListForApplicant(id) {
  return API.get(`/sys_users/hrms_portfolio/get/${id}`);
}

export function getPortfolioList(id) {
  return API.get(`/hrms_user_portfolio/byUserId/${id}`);
}

export function getBankList() {
  return API.get(`/hrms_bank`);
}

export function getUserBankList(id) {
  return API.get(`/hrms_user_bank_info/getBank/${id}`);
}

export function getUserBankListForApplicant(id) {
  return API.get(`/hrms_user_bank_info/getBank/${id}`);
}

export function getAllReferenceList(id) {
  return API.get(`/hrms_user_references/byUserId/${id}`);
}
export function getDisciplinaryRecord(id) {
  return API.get(`/hrms_employee_disciplinary_record/byUserId/${id}`);
}
export function getWorkStation(id) {
  return API.get(`/hrms_employee_work_station/byUserId/${id}`);
}
export function getFRC(id) {
  return API.get(`/hrms_employee_frc/byUserId/${id}`);
}

export function getObjective(id) {
  return API.get(`/hrms_applicant/get-objective/${id}`);
}

export function getJobDescriptionQuestionTypeList() {
  return API.get(`/hrms_question_type`);
}

export function updateHodStatus(payload) {
  return API.post(`/hrms_job_application/update-hod-status`, payload);
}

export function getAccessorData(payload) {
  return API.post(`/hrms_interview_schedule/get/assesors/data`, payload);
}

export function getIntervieweTypeByReq(req_id) {
  return API.get(`/hrms_question_type?requisition_id=${req_id}`);
}

export function getApplicantSocialMedia(applicant_id) {
  // return API.get(`http://localhost:6013/hrms_applicant_social_media/${applicant_id}`);
  return API.get(
    `/hrms-applicant-portal/hrms_applicant_social_media/${applicant_id}`
  );
}

export function updateProfileScore(params) {
  return API.patch(
    `/hrms-applicant-portal/hrms_applicant_profile_percentage`,
    params
  );
}

export function createProfileScorePublic(params) {
  return API.post(
    `/hrms-applicant-portal/hrms_applicant_profile_percentage`,
    params
  );
}
